var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal fade mobile-friendly",attrs:{"id":_vm.id,"tabindex":"-1","aria-labelledby":_vm.id,"aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-dialog-centered modal-dialog-scrollable"},[_c('div',{staticClass:"modal-content p-4"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }